<app-navbar [logoImage] = "logoImage"></app-navbar>
<!--<app-media></app-media>-->
<router-outlet></router-outlet>
<app-footer *ngIf="removeFooter()"></app-footer>
<app-scrollTop *ngIf="isScrollTop"></app-scrollTop>
